import React, {Component} from 'react';
import WebNews from "../webNews/webNews";
import {Scrollbars} from "react-custom-scrollbars";
import pause from "../../../../../mediaRelease/image/pause (2).png";
import {uuid} from "../../../../../../utils";
import {checkWordReplace} from "../tool/htmlFormat";

/**
 * creat by tianruojun
 * @description 安全中心快手素材预览模块
 * @class Kuaishou
 * @extends {WebNews}
 */
export default class Kuaishou extends WebNews {
    constructor(props) {
        super(props);
        this.state.isPlayVideo = false;
    }
    componentWillMount() {
    }

    componentDidMount() {
    }
    /**
     * 给稿件数据打敏感词标记
     */
    setCheckWord = ({title="",coverUrl="",videoUrl=""}) => {
        const {checkAllWord} = this.props;
        if(checkAllWord?.length) {
            checkAllWord.forEach(item=>{
                let itemWord = item.word;//错误词
                let currWord;
                let itemCorrectWord = item.correctWord;//正确词
                if (item.category === "SENSITIVE") {
                    currWord = '“' + itemWord + '”建议修改为：“' + itemCorrectWord + '”';
                } else {
                    currWord = '“' + itemWord + '”建议删除';
                }
                let replaceHtml = '<span class="itemWord word" check="'+currWord+'">'+itemWord+'</span>';
                title = checkWordReplace(title,item?.word,replaceHtml);
            })
        }
        return {title,coverUrl,videoUrl}
    };
    // 内容部分
    renderContent = () => {
        const height = window.innerHeight - 24 - 20;
        const width = window.innerWidth - 680;// 左右各留340距离
        const publicStyle = {
            fontWeight: '400',
            marginBottom: '24px'
        };
        let {title,coverUrl,videoUrl} = this.getData();
        let {isPlayVideo} = this.state;
        return (
            <div className={'details_content'} style={{height: height,width}}>
                <Scrollbars autoHide autoHeightMax={height}>
                    <div style={{padding: '0 10px'}}>
                        {/*标题*/}
                        <div
                            style={{
                                ...publicStyle,
                                fontSize: 16,
                                textAlign: 'left',
                                color: 'rgba(0, 0, 0, 0.85)',
                            }}
                            dangerouslySetInnerHTML={{__html: title}}
                        >
                        </div>
                        {/*视频*/}
                        <div
                            style={{position: 'relative',width: 333, height: 592,background: "#000"}}
                            onClick={() => {
                                 if (isPlayVideo) {
                                     this['videoNode'].pause();
                                 } else {
                                     this['videoNode'].play();
                                 }
                                 this.setState({isPlayVideo: !isPlayVideo});
                             }}>
                            <div data-vjs-player
                                 style={{
                                     width: 333,
                                     height: 592,
                                     position: 'absolute',
                                 }}>
                                <video
                                    id={"videoCoverSize"}
                                    ref={node => this['videoNode'] = node}
                                    style={this.state.proportion == 0 ? {
                                        height: "100%",
                                        width: "100%",
                                        objectFit: "cover",
                                        borderRadius: "23px 23px 0 0"
                                    } : {width: "100%", height: "100%"}}
                                    autoPlay={false}//播放器准备好之后，是否自动播放 【默认false】
                                    loop={true} //视频播放结束后，是否循环播放
                                    controls={false} // 视频控件
                                    responsive="true"
                                    fluid="true"
                                    // muted={this.props.muted ? this.props.muted : false}//是否静音
                                    src={videoUrl}
                                    // poster={coverUrl}
                                >
                                </video>
                            </div>
                            {/* 暂停图标*/}
                            {!isPlayVideo ? <img src={pause} style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                marginTop: ' -20px',
                                marginLeft: ' -20px',
                                width: 48,
                                height: 48
                            }}/> : null}
                        </div>
                    </div>
                    <style>
                        {`
                        font.word {
                        color: #fff;
                        background-color: red;
                        cursor: pointer;
                        }
                    `}
                    </style>
                </Scrollbars>

            </div>
        )
    };

}